import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './../firebase/firebaseConfig';
import './css/Login.css';
import PageTitle from './includes/PageTitle';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Get the current domain dynamically
  const currentDomain = window.location.origin;

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setLoading(true);

    

    try {
      await sendPasswordResetEmail(auth, email, {
        url: `${currentDomain}/change-password?origin=forgot-password`,
      });
      setSuccessMessage('Password reset email sent. Check your inbox.');
      setTimeout(() => {
        navigate('/sign-in');
      }, 3000);
    } catch (error) {
      setErrorMessage("An error occurred while sending the password reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle title="Forgot Password - ALMOSTINVISIBLE" />
      <div style={{ marginTop: "5vh", display: "flex", justifyContent: "center" }}>
        <form className="form" onSubmit={handlePasswordReset}>
          <h1 className="unbounded black-bordered-bottom">FORGOT PASSWORD</h1>

          {successMessage && (
            <div className="alert alert-success alert-dismissible fade show mt-3" role="alert">
              {successMessage}
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          )}
          {errorMessage && (
            <div className="alert alert-danger alert-dismissible fade show mt-3" role="alert">
              {errorMessage}
              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          )}

          <div>
            <div className="flex-column">
              <label className='nunito-2'>Email*</label>
            </div>
            <div className="inputForm">
              <input
                type="email"
                className="input"
                placeholder="Enter your email"
                value={email}
                autoComplete='on'
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <button className="black-button" type="submit" disabled={loading}>
              {loading ? <div className="spinner-border spinner-border-sm" role="status"></div> : 'Send Password Reset Email'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
